import useAuth from '@/compositions/useAuth';

const { logOut } = useAuth();

export default async function logOutMiddleware(to, from, next) {
  await logOut();
  next({ name: 'WelcomeScreen' });
}
